'use client';

import { useAuth } from '@/contexts/AuthContext';
import EmailOtpGateModal from '@/components/EmailOtpGateModal';

/**
 * Gate global: memblokir SELURUH aplikasi (route apa pun, termasuk /onboarding &
 * /pilih-perusahaan yang tidak memakai ProtectedRoute) sampai email terverifikasi
 * via OTP. Dipasang di root layout, di dalam AuthProvider.
 */
export default function AuthGate() {
  const { needsEmailVerification } = useAuth();
  if (!needsEmailVerification) return null;
  return <EmailOtpGateModal />;
}
